"use client"

import { Adsense } from "@ctrl/react-adsense"
import { isPublisherId } from "@/components/google-ads/utils"

type AdSenseProps = {
  slotId: string
  layout: "display" | "in-article"
}

// Individual AdSense Unit (NOT GLOBAL). 
// Global is in AdSenseProvider
// *************************************

export default function AdSense({ slotId, layout }: AdSenseProps) {
  const _publisherId = process.env.NEXT_PUBLIC_ADSENSE_PUBLISHER_ID

  if (!_publisherId) {
    console.error(
      "❌ [google-adsense] No AdSense Publisher ID found. Please set NEXT_PUBLIC_ADSENSE_PUBLISHER_ID in your .env file"
    )
    return null
  }

  if (!isPublisherId(_publisherId)) {
    console.error(
      "❌ [google-adsense] Invalid publisherId. It should be like this: pub-xxxxxxxxxxxxxxxx, there is a total of 16 digits behind pub-"
    )
    return null
  }

  

  return (
    <Adsense
      client={_publisherId}
      slot={slotId}
      layout={layout}
      // format="auto"
      //only add fluid if layout is in-article
      format={layout === "in-article" ? "fluid" : "auto"}
    />
  )

  // return <AdUnit  slotId={slotId} layout={layout} />;
}
